export enum ViewerTimeZoneType {
  Auto = 1,
  Fixed = 2,
}
